import { loadScrollTrigger } from "@/core/utils/lazyGsap";

type RefType = {
  current: HTMLElement | null;
};

let gsapLoaded = false;
let gsap: any = null;
let ScrollTrigger: any = null;

const ensureGSAPLoaded = async () => {
  if (!gsapLoaded) {
    const modules = await loadScrollTrigger();
    gsap = modules.gsap;
    ScrollTrigger = modules.ScrollTrigger;
    gsapLoaded = true;
  }
};

export const animateTitle = async (
  titleRef: RefType,
  delay: number = 0
): Promise<void> => {
  if (!titleRef.current) return;

  await ensureGSAPLoaded();

  gsap.fromTo(
    titleRef.current,
    { opacity: 0, y: 30 },
    {
      opacity: 1,
      y: 0,
      duration: 1,
      delay,
      ease: "power3.out",
      id: "productsHero-title",
    }
  );
};

export const animateSubtitle = async (
  subtitleRef: RefType,
  delay: number = 0.3
): Promise<void> => {
  if (!subtitleRef.current) return;

  await ensureGSAPLoaded();

  gsap.fromTo(
    subtitleRef.current,
    { opacity: 0, y: 20 },
    {
      opacity: 1,
      y: 0,
      duration: 0.8,
      delay,
      ease: "power3.out",
      id: "productsHero-subtitle",
    }
  );
};

export const animateOverlay = async (overlayRef: RefType): Promise<void> => {
  if (!overlayRef.current) return;

  await ensureGSAPLoaded();

  gsap.fromTo(
    overlayRef.current,
    { opacity: 0 },
    {
      opacity: 1,
      duration: 1.5,
      ease: "power2.inOut",
      id: "productsHero-overlay",
    }
  );
};

export const animateButton = async (
  buttonRef: RefType,
  delay: number = 1
): Promise<void> => {
  if (!buttonRef.current) return;

  await ensureGSAPLoaded();

  gsap.fromTo(
    buttonRef.current,
    { opacity: 0, y: 20 },
    {
      opacity: 1,
      y: 0,
      duration: 0.6,
      delay,
      ease: "power3.out",
      id: "productsHero-button",
    }
  );
};

export const cleanupAnimations = (): void => {
  if (!gsapLoaded) return;

  const targets = [
    '[id="productsHero-title"]',
    '[id="productsHero-subtitle"]',
    '[id="productsHero-overlay"]',
    '[id="productsHero-button"]',
  ];

  targets.forEach((selector) => {
    gsap?.killTweensOf(selector);
  });

  ScrollTrigger?.getAll()
    .filter((trigger: any) => trigger.vars.id?.startsWith("productsHero"))
    .forEach((trigger: any) => trigger.kill());
};
